import React from 'react';
import { motion } from "framer-motion";
import historyImage from '../../assets/videos/aboutVideo.mp4';
import '../../components/AboutPage/AboutPage.css';
import '../../styles/CustomClassCss/Custom.css';

const AboutPage = () => {
  const contentVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeInOut" },
    },
  };

  const imageVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeInOut" },
    },
  };

  return (
    <div className="about-page  custom-container-upper">
      <div className="container ">
        <div className="about-top font-poppins custom-inner-space">
          About Stelmart
        </div>
        <div className="about-grid custom-inner-space">
          <motion.div
            className="about-image"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={imageVariant}
          >
          <video src={historyImage} autoPlay muted loop playsInline style={{ width: '100%', borderRadius: '10px' }} />
          </motion.div>

          <motion.div
            className="about-content"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={contentVariant}
          >
            <h2 className='font-merriweather'>
              SIMPLIFYING STEEL AND POLYMER PURCHASES WITH STELMART
            </h2>
            <p className='font-poppins'>
            Finding the right steel and polymer products should never be a hassle. Whether you're an individual or a business, Stelmart makes it easy to purchase high-quality materials at competitive prices.              </p>
            <p className='font-poppins'>
            Gone are the days of endless research and complex transactions. Stelmart's intuitive platform allows you to browse, compare, and purchase steel and polymer products with ease, making the entire buying process easy and stress-free.            </p>
          </motion.div>
        </div>
        <div class="text-banner">
          <div class="marquee-container">
            <div class="marquee marquee-rtl ">
              <p>* RENOVATION * CONSTRUCTION * BUILDING * BUSINESS * RENOVATION * CONSTRUCTION * BUILDING * </p>
              <p>* RENOVATION * CONSTRUCTION * BUILDING * BUSINESS * RENOVATION * CONSTRUCTION * BUILDING * </p>
            </div>
          </div>
          <div class="marquee-container">
            <div class="marquee marquee-ltr">
              <p>* RENOVATION * CONSTRUCTION * BUILDING * BUSINESS * RENOVATION * CONSTRUCTION * BUILDING * </p>
              <p>* RENOVATION * CONSTRUCTION * BUILDING * BUSINESS * RENOVATION * CONSTRUCTION * BUILDING * </p>
            </div>
          </div>
        </div>
        </div>
      </div>
      );
};

      export default AboutPage;
